// lib/leasing/source-country-scope.ts
import { toIsoCountryCodes } from '#lib/country-codes';
import type { LeasingPropertyDTO } from '#types/types';

export type SourceCountryMode = 'ASSETS' | 'MANUAL';

export const DEFAULT_SOURCE_COUNTRY_MODE: SourceCountryMode = 'ASSETS';

export const SOURCE_COUNTRY_ASSETS_LABELS = {
  fr: 'Les pays des assets sélectionnés',
  en: 'The countries of the selected assets',
} as const;

export const resolvePropertyCountryCode = (property: Pick<LeasingPropertyDTO, 'country' | 'location'>): string | null => {
  const candidates: unknown[] = [
    property.country,
    property.location?.countryCode,
    property.location?.country,
  ];
  for (const candidate of candidates) {
    const code = toIsoCountryCodes(candidate)[0];
    if (code) return code;
  }
  return null;
};

export const resolveAssetCountryCodes = (
  properties: Array<Pick<LeasingPropertyDTO, 'country' | 'location'>>,
): string[] => {
  const codes = new Set<string>();
  for (const property of properties) {
    const code = resolvePropertyCountryCode(property);
    if (code) codes.add(code);
  }
  return Array.from(codes).sort();
};

export const resolveEffectiveCountryCodes = (
  mode: SourceCountryMode,
  manualCountryCodes: string[],
  properties: Array<Pick<LeasingPropertyDTO, 'country' | 'location'>>,
): string[] => mode === 'MANUAL' ? manualCountryCodes : resolveAssetCountryCodes(properties);
